/**
 * Expo web 全局量的安裝入口。
 *
 * 這個檔自己不做事，只是把「安裝」包成一個**模組副作用**——
 * 因為注入點是 `import '...'`，而 import 的模組體會在**被注入模組的其他 import 之前**
 * 求值（ESM 依序深度優先）。若改成在被注入模組裡直接呼叫，呼叫會晚於那個模組
 * 自己的所有 import，而 `@dp-frontend/ui` 之類的 import 正是會踩到
 * `globalThis.expo` 的那批，時序就反了。
 *
 * 真正的實現在 `expo-modules-core` 裡，這裡只借一條 alias 把它接過來。
 *
 * 起因：`expo-modules-core` 的 `NativeModule` / `EventEmitter` 都讀 `globalThis.expo`，
 * 這個全局量由 `expo` 套件的 winter runtime 在啟動時裝上。Metro 構建會把它注入，
 * Vite 不會 —— 少了它，第一個用到 Expo 模組的檔案一被求值就拋
 * `Cannot read properties of undefined (reading 'EventEmitter')`。
 *
 * app 的 vite-entry.ts 以 `import '@dp-frontend/expo-vite/web-globals'` 把它
 * 放在所有業務 import 之前，順序不能挪。
 */
import { installExpoGlobalPolyfill } from 'dp-expo-modules-polyfill';

installExpoGlobalPolyfill();
